import { makeAutoObservable } from 'mobx';
import { durationOrder, NotificationInterval, createNotificationInterval } from '../Schedule/NotificationInterval';
import dayjs, { Dayjs } from 'dayjs';

/**
 * Created by neo on 17.10.21.
 */

export type UnitSchedule = {
  startDate: string;
  startTime: string;
  timezone: string;
  notificationIntervals: NotificationInterval[];
  readonly earliestInterval: NotificationInterval | undefined;
  readonly latestInterval: NotificationInterval | undefined;
  readonly startTimeFixed: string | undefined;
  readonly startDateTime: Dayjs | undefined;
  readonly notificationsEnabled: boolean;
  copy(): UnitSchedule;
};

export function createUnitSchedule(json?: Partial<UnitSchedule>): UnitSchedule {
  return makeAutoObservable({
    startDate: json?.startDate ?? '',
    startTime: json?.startTime ?? '',
    timezone: json?.timezone ?? 'Europe/Zurich',
    notificationIntervals: (json?.notificationIntervals ?? []).map((n: any) => createNotificationInterval(n)),

    get earliestInterval(): NotificationInterval | undefined {
      return this.notificationIntervals.slice().sort((a, b) => durationOrder.indexOf(b.durationBefore) - durationOrder.indexOf(a.durationBefore))[0];
    },

    get latestInterval(): NotificationInterval | undefined {
      return this.notificationIntervals.slice().sort((a, b) => durationOrder.indexOf(a.durationBefore) - durationOrder.indexOf(b.durationBefore))[0];
    },

    get startTimeFixed(): string | undefined {
      if (this.startTime) {
        return this.startTime.length === 5 ? `${this.startTime}:00` : this.startTime.length >= 8 ? this.startTime.substring(0, 8) : undefined;
      }
      return undefined;
    },

    get startDateTime(): Dayjs | undefined {
      return this.startDate ? dayjs(`${this.startDate} ${this.startTimeFixed ?? '00:00'}`, 'YYYY-MM-DD HH:mm') : undefined;
    },

    get notificationsEnabled(): boolean {
      return this.notificationIntervals.length > 0;
    },

    copy(): UnitSchedule {
      return createUnitSchedule(this);
    },
  });
}
